interface StorageBarProps {
  usedGB: number;
  totalGB: number;
  percentage: number;
  used: string;
  total: string;
  photoCount: number;
  planLabel?: string;
}

export default function StorageBar({ usedGB, totalGB, percentage, used, total, photoCount, planLabel }: StorageBarProps) {
  return (
    <div className="bg-background-50 rounded-2xl border border-background-200 p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-hard-drive-2-line text-accent-600 text-base"></i>
          </div>
          <div>
            <h3 className="text-sm font-bold text-foreground-900">Almacenamiento</h3>
            <p className="text-[11px] text-foreground-400">{photoCount} fotos {planLabel && <span className="text-foreground-300">&bull;</span>} {planLabel && <span className="font-semibold text-foreground-500">{planLabel}</span>}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm font-bold text-foreground-900">
            {used} <span className="text-foreground-400 font-medium text-xs">/ {total}</span>
          </p>
          <p className="text-[10px] text-foreground-400">{percentage}% usado</p>
        </div>
      </div>

      {/* Barra de progreso */}
      <div className="relative w-full h-2.5 rounded-full bg-background-200 overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 rounded-full bg-accent-500 transition-all duration-700"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>

      {/* Marcadores */}
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-[10px] text-foreground-400">0</span>
        <span className="text-[10px] text-foreground-400">{Math.round(totalGB / 2)} GB</span>
        <span className="text-[10px] text-foreground-400">{totalGB} GB</span>
      </div>
    </div>
  );
}